import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import { Row } from 'antd';
import { getAvailableLanguageFromNavigator } from '../../utils/i18nUtils';
import Loading from '../ui/Loading';
import { useEffect } from 'react';

const Internationalization = ({ children }) => {
  const locale = getAvailableLanguageFromNavigator();
  const [messageContent, setMessageContent] = useState(null);
  useEffect(() => {
    import(`../../../i18n/${locale}/translation.json`)
      .then((mod) => {
        setMessageContent(mod.default);
      })
      .catch(() => {
        setMessageContent({});
      });
  }, [locale]);

  return messageContent ? (
    <IntlProvider defaultLocale="en" locale={locale} key={locale} messages={messageContent}>
      {children}
    </IntlProvider>
  ) : (
    <Row type="flex" justify="center" align="middle" style={{ height: '100vh' }}>
      <Loading />
    </Row>
  );
};

Internationalization.propTypes = {
  children: PropTypes.object,
};
export default Internationalization;
